import type { DomainManifest } from 'modules/core/lib/manifests/types'
import { CreateTicketActivity } from 'modules/ticketing/activities/CreateTicket'
import { TicketDetailActivity } from 'modules/ticketing/activities/TicketDetail'
import i18n from 'modules/core/lib/i18n'
import { Inbox } from '@factorialco/f0-react/icons/app'
import { CreateTicketAction } from 'modules/ticketing/lib/oneHandlers/create-ticket'
import { CreateTicketCommentAction } from 'modules/ticketing/lib/oneHandlers/create-ticket-comment'

export const manifest = {
  sidebar: (navigation) => ({
    items: [
      {
        identifier: 'ai_ticketing',
        name: i18n.t('ticketing.sidebar.inbox'),
        factorialOneIcon: Inbox,
        path: navigation.ticketing.fullPath(),
        group: 'it_management',
        module: 'ai_ticketing',
        priority: 'low',
      },
    ],
  }),
  one: {
    createActions: {
      ticket: CreateTicketAction,
      ticketComment: CreateTicketCommentAction,
    },
  },
  activities: {
    createTicket: {
      component: CreateTicketActivity,
      availableForOne: true,
      guidelines:
        'Opens the create ticket dialog. Do not open until the user has described the issue — you need the description to resolve the correct categoryId via fetchTicketCategories. If the user only says they want to create a ticket without details, ask what the issue is about first.',
      params: {
        title: {
          guidelines:
            'A clear, concise title summarizing the issue. Derive from the user\'s description — do not use generic titles like "New ticket".',
        },
        description: {
          guidelines:
            'Detailed description of the issue or request. Must reflect what the user actually described.',
        },
        categoryId: {
          guidelines:
            'The ID of the ticket category. Use fetchTicketCategories to resolve category names to IDs based on the user request topic.',
        },
        categoryName: {
          guidelines: 'The name of the ticket category. Resolved via fetchTicketCategories.',
        },
        priority: {
          guidelines:
            'Priority level: "low", "medium", "high", or "critical". Only needed when the category priorityMode is "manual". Infer from context (treat "urgent" as "critical") or default to "medium".',
        },
        createdVia: {
          guidelines:
            'Always pass "factorial_one" to indicate the ticket was created via Factorial One.',
        },
      },
    },
    viewTicket: {
      component: TicketDetailActivity,
      availableForOne: true,
      guidelines:
        'Opens the ticket detail panel to view and manage an existing ticket. Use when the user wants to view, check, inspect, or manage a specific ticket.',
      params: {
        ticketId: {
          guidelines:
            'The ID of the ticket to view. Use available tools to resolve ticket references to IDs. Never ask the user for the ID directly.',
        },
      },
    },
  },
} as const satisfies DomainManifest
